import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { Profile } from 'src/app/models/profile';
import { AlertService } from 'src/app/services/alert/alert.service';
import { PROFILE_TYPE } from 'src/app/constants';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { PaymentService } from 'src/app/services/payment/payment.service';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { InAppBrowserOptions, InAppBrowser } from '@ionic-native/in-app-browser/ngx';

@Component({
  selector: 'profile-create-success',
  templateUrl: './profile-create-success.component.html',
  styleUrls: ['./profile-create-success.component.scss'],
})
export class ProfileCreateSuccessComponent implements OnInit {

  profile: Profile;

  constructor(
    private modal: ModalController,
    private profileService: ProfileService,
    private alert: AlertService,
    private router: Router,
    private spinner: SpinnerService,
    private auth: AuthService,
    private payment: PaymentService,
    private storage: Storage,
    private cd: ChangeDetectorRef,
    private platform: Platform,
    private iab: InAppBrowser,
    private translate: TranslateService,
  ) {
  }

  async ngOnInit() {
    try {
      this.profile = await this.profileService.getProfile();
      if (!this.profile) { throw new Error(); }
    } catch (err) {
      console.log(err);
    }
  }

  async ok() {
    const { type = '' } = this.profile;
    if (type === PROFILE_TYPE.company) {
      this.dismiss();
      return;
    }

    if (type === PROFILE_TYPE.private) {
      // Navigate to profile
      this.dismiss();
    }

    if (type === PROFILE_TYPE.professional) {
      await this.alert.confirm({
        messageKey: 'SUBSCRIPTION_MESSAGE',
        okTextKey: 'ENABLE_SUBSCRIPTION',
        cancelTextKey: 'CANCEL',
        cancelHandler: () => this.dismiss('/profile'),
        okHandler: async () => {
          await this.dismiss();

          try {
            await this.spinner.show();
            const token = await this.auth.getToken();

            const { paymentFormUrl } = await this.profileService.subscription(token);
            this.payment.pay(
              paymentFormUrl,
              () => this.router.navigate(['/thankyou-subscription'], { queryParams: { isCreating: 'true' } }),
              () => this.alert.translate('PAYMENT_ERROR_MESSAGE'),
            );

            await this.spinner.dismiss();

          } catch (err) {
            await this.spinner.dismissWithAlertError(err);
          }
        }
      });
      return;
    }
  }

  async dismiss(url?: string) {
    const { type = '' } = this.profile;
    await this.modal.dismiss({ type });
    
    const lastUserSearch = await this.storage.get('lastUserSearch');

    if (url) {
      this.router.navigate([url], { queryParams: { isCreating: 'true' } });
    } else if (lastUserSearch) {
      await this.router.navigateByUrl(lastUserSearch, { replaceUrl: true });
      await this.storage.remove('lastUserSearch');
    } else {
      this.router.navigate(['../tabs/home']);
    }
  }

  async createStripeConnectAccountLink(openInTab: boolean = false) {
    try {
      await this.spinner.show();
      const token = await this.auth.getToken();
      const body = await this.profileService.getStripeConnectAccountLink(token);
      await this.spinner.dismiss();

      const url = body.accountLink;

      if (!this.platform.is('cordova')) {
        if (openInTab) {
          window.open(url, '_blank');
        } else {
          window.open(url, '_self');
        }
        return;
      }
  
      const CLOSE = await this.translate.get('CLOSE').toPromise();
  
      const options: InAppBrowserOptions = {
        location: 'no',
        hidenavigationbuttons: 'yes',
        closebuttoncaption: CLOSE,
        usewkwebview: 'yes',
        cleardata: 'yes',
      };
  
      const browser = this.iab.create(url, '_blank', options);
      browser.on('loadstart').subscribe(async (e) => {
        if (e.url.includes('success')) {
          browser.close();
          this.onStripeConnectAccountCreationSuccess();
        } else if (e.url.includes('error')) {
          browser.close();
          this.onStripeConnectAccountCreationError();
        } else if (e.url.includes('cancel') || e.url.includes('home')) {
          browser.close();
          this.onStripeConnectAccountCreationError();
        }
      });
    } catch (err) {
      
      await this.spinner.dismissWithAlertError(err);
    }
  }

  async onStripeConnectAccountCreationSuccess() {
    this.router.navigate(['/profile', ], { replaceUrl: true, queryParams: { segment: '2' } });
  }

  async onStripeConnectAccountCreationError() {
    this.router.navigate(['/profile'], { replaceUrl: true, queryParams: { segment: '2' } });
  }
}
